const modalEvent = () =>
  new CustomEvent("markup-modal:open", {
    bubbles: true,
    detail: {
      target: "contact-modal",
      html: document.importNode(
        document.querySelector("[data-contact-form]").content,
        true,
      ),
    },
  });

class ContactModalTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.link = this.closest("a");

    if (!this.link) return;

    this.link.addEventListener("click", (e) => {
      e.preventDefault();

      this.link.dispatchEvent(modalEvent());
    });
  }

  disconnectedCallback() {}

  _getData() {
    if (this._data) return Promise.resolve(this._parseData(this._data));
    if (this.loadingData) return this.loadingData;

    const url = new URL(`${window.location.origin}${this.url}`);

    this.loadingData = fetch(url)
      .then((res) => res.text())
      .then((data) => {
        this._data = data;

        return this._parseData(data);
      });

    return this.loadingData;
  }

  _parseData(data) {
    const section = new DOMParser().parseFromString(data, "text/html");
    const targetEl = document
      .createRange()
      .createContextualFragment(
        section.querySelector("#MainContent").innerHTML,
      );

    return targetEl;
  }

  get url() {
    return this.getAttribute("url");
  }
}

if (!customElements.get("contact-modal-trigger")) {
  customElements.define("contact-modal-trigger", ContactModalTrigger);
}
